// extracted by mini-css-extract-plugin
export default {"nav":"navbar_nav__aDqj0","navItem":"navbar_navItem__CgEMy","active":"navbar_active__XKkh6","indicator":"navbar_indicator__XyKAr","profileImg":"navbar_profileImg__85utP"};